import * as Types from "@clockwise/schema";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type UpdateEventFlexibilityMutationVariables = Types.Exact<{
  input: Types.BatchModifyFlexibilityInput;
  CalendarId: Types.Scalars["CalendarId"];
}>;

export type UpdateEventFlexibilityMutation = {
  __typename: "Mutation";
  batchUpdateFlexibility: Array<{
    __typename: "EventParent";
    id: string;
    externalEventId: string;
    calendarIds: Array<string>;
    flexibilityConstraints:
      | {
          __typename: "FlexibilityConstraints";
          availableMeetingDays: Array<Types.DayOfWeek> | null;
          timeOfDayAllowedByPlan: boolean | null;
          allowedToModify: boolean | null;
          externalEvent: boolean | null;
          dayOfWeekFlexibilityEligible: boolean | null;
          availableMeetingHours: {
            __typename: "AvailableMeetingHours";
            start: any;
            end: any;
          } | null;
        }
      | { __typename: "GraphEntityError" };
    flexibility:
      | {
          __typename: "EventFlexibility";
          isRoomFlexible: boolean | null;
          description: string | null;
          timeRangeFlexibility:
            | { __typename: "DayOfWeekFlexibility"; allowedDays: Array<Types.DayOfWeek> }
            | { __typename: "RangeFlexibility"; range: Types.FlexibilityRange };
          timeOfDayFlexibility: {
            __typename: "TimeOfDayFlexibility";
            start: any | null;
            end: any | null;
          } | null;
        }
      | { __typename: "GraphEntityError"; message: string | null }
      | null;
  }> | null;
};

export const UpdateEventFlexibilityDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateEventFlexibility" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BatchModifyFlexibilityInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "CalendarId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CalendarId" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "batchUpdateFlexibility" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "externalEventId" } },
                { kind: "Field", name: { kind: "Name", value: "calendarIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flexibilityConstraints" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "calendarId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "CalendarId" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "FlexibilityConstraints" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "availableMeetingHours" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "start" } },
                                  { kind: "Field", name: { kind: "Name", value: "end" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "availableMeetingDays" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "timeOfDayAllowedByPlan" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "allowedToModify" } },
                            { kind: "Field", name: { kind: "Name", value: "externalEvent" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "dayOfWeekFlexibilityEligible" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "flexibility" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "calendarId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "CalendarId" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "EventFlexibility" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "timeRangeFlexibility" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "RangeFlexibility" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "range" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "DayOfWeekFlexibility" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "allowedDays" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "timeOfDayFlexibility" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "start" } },
                                  { kind: "Field", name: { kind: "Name", value: "end" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "isRoomFlexible" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "GraphEntityError" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<
  UpdateEventFlexibilityMutation,
  UpdateEventFlexibilityMutationVariables
>;
